import { atom } from "jotai";

export const AlertAtom = atom<boolean>(false);
